<template>
	<div :class="$style['notification-stack']">
		<GlobalNotifications />
		<NotificationToasts
			:toasts="toasts"
			:duration="duration"
			@close="removeToast"
			@action="emitAction"
			@success="emitAction"
			@delete="emitAction"
		/>
	</div>
</template>

<script>
import GlobalNotifications from '@c:essentials/Notification'
import EventBus from '@/utils/event-bus'
import NotificationToasts from './NotificationToasts'
import { toastState, removeToast, TOAST_DURATION } from './toasts'

export default {
	name: 'NotificationStack',
	components: {
		GlobalNotifications,
		NotificationToasts
	},
	data () {
		return {
			duration: TOAST_DURATION
		}
	},
	computed: {
		toasts () {
			return toastState.toasts
		}
	},
	methods: {
		removeToast,
		emitAction (notification) {
			EventBus.$emit('notification-toast:action', notification)
		}
	}
}
</script>

<style lang="scss" module>
.notification-stack {
    position: fixed;
    z-index: 10000;
    right: $gutter * 2;
    bottom: $gutter * 3;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: $gutter;
    pointer-events: none;
}
</style>
